import { render, staticRenderFns } from "./abInyjzy.vue?vue&type=template&id=bd628894&scoped=true&"
import script from "./abInyjzy.vue?vue&type=script&lang=js&"
export * from "./abInyjzy.vue?vue&type=script&lang=js&"
import style1 from "./abInyjzy.vue?vue&type=style&index=1&id=bd628894&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd628894",
  null
  
)

export default component.exports